/* Sidebar / mobile menu: the arrow next to Shop folds the category list open and shut. */
document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-lushe-sub-toggle]');
  if (!toggle) return;
  var list = toggle.parentElement.querySelector('.lushe-sidebar__sub');
  if (!list) return;
  var open = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
  list.hidden = open;
});
